<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
		</el-row>

		<el-row class="mg-b10">
			<el-table :data="tableData">
				<el-table-column prop="jobName" label="任务名称" width="150"></el-table-column>
				<el-table-column prop="remark" label="备注" width="150"></el-table-column>
				<el-table-column prop="invokeTarget" label="调用目标字符串" width="280"></el-table-column>
				<el-table-column prop="cronExpression" label="cron执行表达式"></el-table-column>
				<el-table-column prop="status" label="状态" width="100">
					<template slot-scope="scope">
						<el-switch active-color="#13ce66" active-value="0" inactive-value="1" v-model="scope.row.status"
							@change="changeSwitch(scope.row)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
				<el-table-column label="操作" width="250">
					<template slot="header" slot-scope="scope">
						<el-button size="mini" type="primary" plain @click="handleAdd">新增
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)">修改
						</el-button>
						<el-button type="text" icon="el-icon-circle-check" size="mini" @click="handleRun(scope.row)">
							执行一次
						</el-button>
						<el-button type="text" icon="el-icon-delete" size="mini" @click="handleDel(scope.row)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<el-dialog :visible.sync="openDialog" width="800px" :title="title">
			<el-form label-width="120px" ref="form" :model="form" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="任务名称" prop="jobName">
							<el-input v-model="form.jobName" placeholder="请输入任务名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="调用目标" prop="clsaaName">
							<el-input v-model="form.clsaaName" placeholder="请选择调用业务类" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="form.remark" placeholder="请填写备注" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="业务类方法" prop="invokeTarget">
							<el-input v-model="form.invokeTarget" placeholder="请选择业务类方法" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="cron表达式" prop="cronExpression">
							<el-input v-model="form.cronExpression" placeholder="cron表达式必填项" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="执行策略" prop="misfirePolicy">
							<el-radio-group v-model="form.misfirePolicy">
								<el-radio label="0">立即执行</el-radio>
								<el-radio label="1">执行一次</el-radio>
								<el-radio label="3">放弃执行</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="并发执行" prop="concurrent">
							<el-radio-group v-model="form.concurrent">
								<el-radio label="0">允许</el-radio>
								<el-radio label="1">禁止</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="状态" prop="status">
							<el-radio-group v-model="form.status">
								<el-radio label="0">启用</el-radio>
								<el-radio label="1">停用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>

				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="openDialog = false">取 消</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		queryAll,
		saveJob,
		runJob,
		delJob,
		editJob,
		pauseJob,
		resumeJob
	} from '@/api/monitor/quartzJob.js'

	export default {
		name: "Job",
		computed: {},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				openDialog: false,
				rules: {
					jobName: [{
						required: true,
						message: '任务名称不能为空',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
			this.getList();
		},
		methods: {
			async getList() {
				let _this = this;
				const {
					data: res
				} = await queryAll()
				if (res.code == 0) {
					_this.tableData = res.data;
				} else {
					_this.$fail(res.msg);
				}
			},
			// 表单重置
			reset: function() {
				if (this.$refs.menu != undefined) {
					this.$refs.menu.setCheckedKeys([]);
				}
				this.form = {
					jobId: undefined,
					jobName: undefined,
					jobGroup: 'DEFAULT',
					invokeTarget: undefined,
					cronExpression: undefined,
					misfirePolicy: undefined,
					clsaaName: 'myjobTask',
					concurrent: undefined,
					status: undefined,
					createBy: undefined,
					remark: undefined,
				};
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						if (_this.form.jobId != undefined) {
							editJob(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
							saveJob(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
			//立即执行
			handleRun: function(row) {
				let _this = this;
				runJob(row).then(response => {
					if (response.data.code === 0) {
						_this.$success(response.data.msg);
						_this.openDialog = false;
						_this.getList();
					} else {
						_this.$fail(response.data.msg);
					}
				});
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增角色表";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				let _this = this;
				_this.reset();
				_this.title = "修改定时任务";
				_this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				_this.form.clsaaName = 'myjobTask';
				_this.openDialog = true;

			},
			handleDel: function(row) {
				let _this = this;
				_this.confirm({
					text: '确认删除定时任务吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delJob(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.open = false;
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: row //参数对象 主要回调函数用
				});
			},
			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			},
			changeSwitch(row) {
				let _this = this;
				if (row.status == 0) {
					//开启
					resumeJob({
						jobId: row.jobId
					}).then(response => {
						if (response.data.code === 0) {
							_this.$success(response.data.msg);
							_this.getList();
						} else {
							_this.$fail(response.data.msg);
						}
					});
				} else {
					//关闭
					pauseJob({
						jobId: row.jobId
					}).then(response => {
						if (response.data.code === 0) {
							_this.$success(response.data.msg);
							_this.getList();
						} else {
							_this.$fail(response.data.msg);
						}
					});
				}
			}
		}
	};
</script>
<style scoped="scoped">
</style>
